"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _theme = require("@tablekit/theme");

var _getButtonStyles = require("./getButtonStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getAlignment = function getAlignment(p) {
  return p.followsIcon ? 'baseline' : 'center';
};

function getMargin(_ref) {
  var hasIconAfter = _ref.hasIconAfter,
      hasIconBefore = _ref.hasIconBefore;
  var leftMargin = hasIconBefore ? _theme.SPACING.L2 : 0;
  var rightMargin = hasIconAfter ? _theme.SPACING.L2 : 0;
  return "0 ".concat(rightMargin, " 0 ").concat(leftMargin);
}

var ButtonContent = (0, _styledBase["default"])("span", {
  target: "e5wjybi0",
  label: "ButtonContent"
})("display:flex;align-items:", getAlignment, ";align-self:", getAlignment, ";margin:", getMargin, ";max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:", _theme.FONT_WEIGHTS.BOLD, ";", _getButtonStyles.getLoadingStyle, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbkNvbnRlbnQuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCMkQiLCJmaWxlIjoiQnV0dG9uQ29udGVudC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHR5cGUgeyBDb21wb25lbnRUeXBlLCBOb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgRk9OVF9XRUlHSFRTLCBTUEFDSU5HIH0gZnJvbSAnQHRhYmxla2l0L3RoZW1lJztcbmltcG9ydCB0eXBlIHsgU2l6ZVR5cGUgfSBmcm9tICdAdGFibGVraXQvdGhlbWUvdHlwZXMnO1xuaW1wb3J0IHsgZ2V0TG9hZGluZ1N0eWxlIH0gZnJvbSAnLi9nZXRCdXR0b25TdHlsZXMnO1xuXG50eXBlIFByb3BzVHlwZSA9IHtcbiAgY2hpbGRyZW46IE5vZGUsXG4gIGZvbGxvd3NJY29uOiBib29sZWFuLFxuICBoYXNJY29uQWZ0ZXI6IGJvb2xlYW4sXG4gIGhhc0ljb25CZWZvcmU6IGJvb2xlYW4sXG4gIGlzTG9hZGluZzogYm9vbGVhbixcbiAgc2l6ZTogU2l6ZVR5cGVcbn07XG5cbmNvbnN0IGdldEFsaWdubWVudCA9IChwOiBQcm9wc1R5cGUpID0+IChwLmZvbGxvd3NJY29uID8gJ2Jhc2VsaW5lJyA6ICdjZW50ZXInKTtcblxuZnVuY3Rpb24gZ2V0TWFyZ2luKHsgaGFzSWNvbkFmdGVyLCBoYXNJY29uQmVmb3JlIH06IFByb3BzVHlwZSkge1xuICBjb25zdCBsZWZ0TWFyZ2luID0gaGFzSWNvbkJlZm9yZSA/IFNQQUNJTkcuTDIgOiAwO1xuICBjb25zdCByaWdodE1hcmdpbiA9IGhhc0ljb25BZnRlciA/IFNQQUNJTkcuTDIgOiAwO1xuICByZXR1cm4gYDAgJHtyaWdodE1hcmdpbn0gMCAke2xlZnRNYXJnaW59YDtcbn1cblxuY29uc3QgQnV0dG9uQ29udGVudDogQ29tcG9uZW50VHlwZTxQcm9wc1R5cGU+ID0gc3R5bGVkLnNwYW5gXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiAke2dldEFsaWdubWVudH07XG4gIGFsaWduLXNlbGY6ICR7Z2V0QWxpZ25tZW50fTtcbiAgbWFyZ2luOiAke2dldE1hcmdpbn07XG4gIG1heC13aWR0aDogMTAwJTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIGZvbnQtd2VpZ2h0OiAke0ZPTlRfV0VJR0hUUy5CT0xEfTtcbiAgJHtnZXRMb2FkaW5nU3R5bGV9O1xuYDtcblxuQnV0dG9uQ29udGVudC5kaXNwbGF5TmFtZSA9ICdCdXR0b25Db250ZW50JztcblxuZXhwb3J0IGRlZmF1bHQgQnV0dG9uQ29udGVudDtcbiJdfQ== */"));
ButtonContent.displayName = 'ButtonContent';
var _default = ButtonContent;
exports["default"] = _default;